import $ from 'jquery';
import {gsap} from "gsap";
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { isMobile } from 'detect-touch-device';
import CustomAnimation from "src/scripts/modules/CustomAnimation";

const animations = new CustomAnimation();
let smoother;

// Synchronisations-Parameter: identisch zu deiner CSS-Transition
const NAV_DUR = 0.6; // Sekunden, wie im CSS (transition: .8s ...)
const NAV_EASE = "cubic-bezier(0.165, 0.840, 0.440, 1.000)"; // easeOutQuart
const NAV_DELAY_OPEN = 0.2; // leichter Delay fürs Öffnen
const PAGE_SHIFT = '-20%'; // px (sanfter „Slide“ nach links). Alternativ: xPercent: -3

function openNavigation() {
  $('.top_burger').addClass('open');
  $('.navbar_main').addClass('open');

  // block scroller
  if(!isMobile) {
    smoother = animations.getSmoother();
    smoother.paused(true);
  }

  // page leicht nach links schieben – synchron zur Navbar-Transition
  gsap.to('.page', {
    x: PAGE_SHIFT,            // oder xPercent: -3
    duration: NAV_DUR,
    ease: NAV_EASE,
    delay: NAV_DELAY_OPEN,
    overwrite: 'auto'
  });



  // nav-item
  $('.nav-item').each(function( i ) {
    let delay = 0;//$(this).data('delay');

    gsap.set( $(this), {
      left: '200px',
      autoAlpha: 0
    });
    gsap.to($(this), {
      duration: .8,
      ease: "power3.out",
      left: 0,
      delay: 0 + (i*.05) + delay,
      autoAlpha: 1,
      stagger: 0.05
    });
  });
}

function closeNavigation() {
  $('.top_burger').removeClass('open');
  $('.navbar_main').removeClass('open');

  // block scroller
  if(!isMobile) {
    smoother = animations.getSmoother();
    smoother.paused(false);
  }



  // page zurück animieren – synchron zur Navbar-Transition
  gsap.to('.page', {
    x: 0,
    duration: NAV_DUR,
    ease: NAV_EASE,
    delay: NAV_DELAY_OPEN,
    overwrite: 'auto'
  });



  // nav-item
  $('.nav-item').each(function( ) {

    gsap.set( $(this), {
      left: '0',
      autoAlpha: 1
    });
    gsap.to($(this), {
      duration: .8,
      ease: "power3.out",
      autoAlpha: 0,
      stagger: 0.05
    });
  });
}

class ModuleNavigation {
  init() {
    this.initPage();
    this.initListener();
  }

  initPage = () => {
    gsap.registerPlugin(ScrollToPlugin );

    //openNavigation();
  }

  initListener = () => {

    $('.btn_imprint, .btn_policy').click(function() {
      closeNavigation();
    });

    $('.top_burger').click(function(event) {
      event.preventDefault();

      if (!$(this).hasClass("open"))
      {
        openNavigation();
      }
      else
      {
        closeNavigation();
      }
    });


    $( '.nav-link, .top_logo, .scroll-down-link' ).on( 'click', function( event )
    {
      event.preventDefault();

      const href = $(this).attr('href');

      if (!href || href === '#') {
        closeNavigation();
        return;
      }

      closeNavigation();

      if(!isMobile) {
        smoother = animations.getSmoother();
        // ScrollSmoother übernimmt das Scrollen im Desktop
        smoother.scrollTo(href, true);
      } else {
        // iPad/iOS: ScrollToPlugin nutzen
        gsap.to(window, {
          duration: 1.2,
          ease: "power4.out",
          scrollTo: {
            y: href,
            // offsetY: 0 // ggf. Höhe eurer fixen Top-Bar berücksichtigen
          }
        });
      }

    });
  }
}

export default ModuleNavigation;
